/**
 * @generated SignedSource<<f945c25bb371b602dc8124bf5b70925e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaultFieldInput_vaultManager$data = {
  readonly id: string;
  readonly vaults: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldValues: ReadonlyArray<{
          readonly field: {
            readonly id: string;
          };
          readonly id: string;
          readonly value: string;
        }>;
        readonly id: string;
      } | null;
    }>;
  };
  readonly " $fragmentType": "VaultFieldInput_vaultManager";
};
export type VaultFieldInput_vaultManager$key = {
  readonly " $data"?: VaultFieldInput_vaultManager$data;
  readonly " $fragmentSpreads": FragmentRefs<"VaultFieldInput_vaultManager">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VaultFieldInput_vaultManager",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VaultConnection",
      "kind": "LinkedField",
      "name": "vaults",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VaultEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Vault",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VaultFieldValue",
                  "kind": "LinkedField",
                  "name": "fieldValues",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "VaultField",
                      "kind": "LinkedField",
                      "name": "field",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "value",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VaultManager",
  "abstractKey": null
};
})();

(node as any).hash = "49759a0f175c6096fdf6e94f0631f07e";

export default node;
